const FilterDrawer = (() => {
  // Private variables and methods
  const state = {
    isViewAll: false,
    isSearchActive: false,
    activeFilters: 0
  };

  const selectors = {
    closeButton: '.filter-drawer__close',
    filterDrawer: '.filter-drawer',
    dropdownToggles: '.filter-group__dropdown-toggle',
    searchInputs: '[data-filter-search]',
    clearButton: '.filter-drawer__clear',
    applyButton: '.filter-drawer__apply',
    checkboxes: '.filter-group__label input[type="checkbox"]',
    openButton: '#openDrawer'
  };

  const handleOpen = () => {
    const filterDrawer = document.querySelector(selectors.filterDrawer);
    filterDrawer?.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    
    // Dispatch event for other components to listen to
    document.dispatchEvent(new CustomEvent('filter-drawer:opened'));
  };  

  const handleClose = () => {
    const filterDrawer = document.querySelector(selectors.filterDrawer);
    filterDrawer?.classList.remove('is-open');
    document.body.style.overflow = '';
  };

  const handleViewAll = (toggle, list, filterItems, viewAllIcon, chevronIcon) => {
    const isViewAll = toggle.getAttribute('data-view-all') === 'true';
    const searchInput = list.previousElementSibling?.querySelector(selectors.searchInputs);
    const isSearchActive = searchInput && searchInput.value.trim() !== '';
    const viewAllText = toggle.getAttribute('data-view-all-text');
    const viewLessText = toggle.getAttribute('data-view-less-text');

    if (isSearchActive) return;

    if (isViewAll) {
      filterItems.forEach((item, index) => {
        item.style.display = index >= 5 ? 'none' : 'flex';
      });
      if (viewAllIcon) viewAllIcon.textContent = viewAllText;
      if (chevronIcon) chevronIcon.style.display = 'none';
      toggle.setAttribute('data-view-all', 'false');
    } else {
      filterItems.forEach(item => item.style.display = 'flex');
      if (viewAllIcon) viewAllIcon.textContent = viewLessText;
      if (chevronIcon) chevronIcon.style.display = 'none';
      toggle.setAttribute('data-view-all', 'true');
    }
  };

  const handleDropdownToggle = (toggle, expanded) => {
    const list = toggle.nextElementSibling;
    const filterItems = list.querySelectorAll('.filter-group__item');
    const viewAllIcon = toggle.querySelector('.filter-group__dropdown-toggle-icon');
    const chevronIcon = toggle.querySelector('.filter-drawer__sort-chevron');
    const isViewAll = toggle.getAttribute('data-view-all') === 'true';
    const searchInput = list.previousElementSibling?.querySelector(selectors.searchInputs);
    const isSearchActive = searchInput && searchInput.value.trim() !== '';
    const viewAllText = toggle.getAttribute('data-view-all-text');
    const viewLessText = toggle.getAttribute('data-view-less-text');

    // Handle price range filter or other filters without items
    if (filterItems.length === 0) {
      if (chevronIcon) {
        chevronIcon.style.display = expanded ? 'block' : 'block';
      }
      list.hidden = expanded;
      return;
    }

    if (!expanded) {
      if (isViewAll && !isSearchActive) {
        filterItems.forEach(item => item.style.display = 'flex');
        if (viewAllIcon) {
          viewAllIcon.textContent = viewLessText;
          viewAllIcon.style.display = 'block';
        }
        if (chevronIcon) chevronIcon.style.display = 'none';
      } else {
        filterItems.forEach((item, index) => {
          item.style.display = index >= 5 ? 'none' : 'flex';
        });
        if (filterItems.length > 5 && !isSearchActive) {
          if (viewAllIcon) {
            viewAllIcon.classList.remove('hidden');
            viewAllIcon.textContent = viewAllText;
            viewAllIcon.style.display = 'block';
          }
          if (chevronIcon) chevronIcon.style.display = 'none';
        } else {
          if (viewAllIcon) {
            viewAllIcon.classList.add('hidden');
            viewAllIcon.style.display = 'block';
          }
          if (chevronIcon) chevronIcon.style.display = 'none';
        }
      }
    } else {
      if (viewAllIcon) viewAllIcon.style.display = 'none';
      if (chevronIcon) chevronIcon.style.display = 'block';
    }

    list.hidden = expanded;
  };

  const handleSearch = (input) => {
    const searchTerm = input.value.toLowerCase();
    const filterItems = input.closest('.filter-group__list').querySelectorAll('.filter-group__item');
    const viewAllIcon = input.closest('.filter-group').querySelector('.filter-group__dropdown-toggle-icon');
    const chevronIcon = input.closest('.filter-group').querySelector('.filter-drawer__sort-chevron');
    const filterGroup = input.closest('.filter-group');
    const toggle = filterGroup.querySelector('.filter-group__dropdown-toggle');
    const isViewAll = toggle.getAttribute('data-view-all') === 'true';
    const viewAllText = toggle.getAttribute('data-view-all-text');
    const viewLessText = toggle.getAttribute('data-view-less-text');

    filterItems.forEach(item => {
      const label = item.querySelector('.filter-group__label').textContent.toLowerCase();
      item.style.display = label.includes(searchTerm) ? 'flex' : 'none';
    });

    if (searchTerm.trim() !== '') {
      if (viewAllIcon) viewAllIcon.classList.add('hidden');
      if (chevronIcon) chevronIcon.style.display = 'none';
    } else {
      if (isViewAll) {
        filterItems.forEach(item => item.style.display = 'flex');
        if (viewAllIcon) {
          viewAllIcon.classList.remove('hidden');
          viewAllIcon.textContent = viewLessText;
        }
        if (chevronIcon) chevronIcon.style.display = 'none';
      } else {
        filterItems.forEach((item, index) => {
          item.style.display = index < 5 ? 'flex' : 'none';
        });
        if (filterItems.length > 5 && viewAllIcon) {
          viewAllIcon.classList.remove('hidden');
          viewAllIcon.textContent = viewAllText;
          if (chevronIcon) chevronIcon.style.display = 'none';
        }
      }
    }
  };

  const checkActiveFilters = () => {
    const checkedInputs = document.querySelectorAll(`${selectors.checkboxes}:checked`);
    const clearButton = document.querySelector(selectors.clearButton);
    clearButton?.classList.toggle('filter-drawer__clear--active', checkedInputs.length > 0);
  };

  const handleClear = () => {
    const checkboxes = document.querySelectorAll(selectors.checkboxes);
    checkboxes.forEach(checkbox => checkbox.checked = false);
    document.querySelector(selectors.clearButton)?.classList.remove('filter-drawer__clear--active');
  };

  const handleApply = () => {
    const checkedInputs = Array.from(document.querySelectorAll(`${selectors.checkboxes}:checked`));
    const formData = new FormData();
    checkedInputs.forEach(input => formData.append(input.name, input.value));

    const url = new URL(window.location.href);
    const searchParams = new URLSearchParams();
    
    // Check if we're on the search page
    const isSearchPage = url.pathname.includes('/search');
    
    if (isSearchPage) {
      // On search page, preserve existing params
      const existingParams = new URLSearchParams(url.search);
      existingParams.forEach((value, key) => {
        searchParams.set(key, value);
      });
    }
    
    // Add new filter params
    formData.forEach((value, key) => {
      searchParams.append(key, value);
    });

    // Add price range filters
    if (window.getPriceRangeValues) {
      const priceFilters = window.getPriceRangeValues();
      if (priceFilters.length > 0) {
        const priceFilter = priceFilters[0]; // Assuming single price range filter
        searchParams.set('filter.v.price.gte', priceFilter.min);
        searchParams.set('filter.v.price.lte', priceFilter.max);
      }
    }

    const sortBySelect = document.getElementById('SortBy');
    if (sortBySelect?.value) {
      searchParams.set('sort_by', sortBySelect.value);
    }

    window.location.href = `${url.pathname}?${searchParams.toString()}`;
  };

  // Public methods
  return {
    init() {
      document.addEventListener('DOMContentLoaded', () => {
        // Initialize close button
        const closeButton = document.querySelector(selectors.closeButton);
        const openButton = document.querySelector(selectors.openButton);
        closeButton?.addEventListener('click', handleClose);
        openButton?.addEventListener('click', handleOpen);

        // Initialize dropdown toggles
        document.querySelectorAll(selectors.dropdownToggles).forEach(toggle => {
          if (!toggle.hasAttribute('data-view-all')) {
            toggle.setAttribute('data-view-all', 'false');
          }

          toggle.addEventListener('click', (e) => {
            if (e.target.classList.contains('filter-group__dropdown-toggle-icon')) {
              const list = toggle.nextElementSibling;
              const filterItems = list.querySelectorAll('.filter-group__item');
              const viewAllIcon = toggle.querySelector('.filter-group__dropdown-toggle-icon');
              const chevronIcon = toggle.querySelector('.filter-drawer__sort-chevron');
              
              // Only handle view all if we have items to show/hide
              if (filterItems.length > 0) {
                handleViewAll(toggle, list, filterItems, viewAllIcon, chevronIcon);
              }
              return;
            }

            const expanded = toggle.getAttribute('aria-expanded') === 'true';
            toggle.setAttribute('aria-expanded', !expanded);
            handleDropdownToggle(toggle, expanded);
          });
        });

        // Initialize search inputs
        document.querySelectorAll(selectors.searchInputs).forEach(input => {
          input.addEventListener('input', () => handleSearch(input));
        });

        // Initialize clear and apply buttons
        const clearButton = document.querySelector(selectors.clearButton);
        const applyButton = document.querySelector(selectors.applyButton);

        checkActiveFilters();
        clearButton?.addEventListener('click', handleClear);
        applyButton?.addEventListener('click', handleApply);

        // Initialize checkbox listeners
        document.querySelectorAll(selectors.checkboxes).forEach(checkbox => {
          checkbox.addEventListener('change', checkActiveFilters);
        });
      });
    },
    open: handleOpen
  };
})();

FilterDrawer.init();
